//
//
//
//
//

export default {
  name: "commons-report",
  data(){
    return{
      reportBaseUrl:process.env.REPORT_URL
    }
  },
  props:['reportStr']
}



// WEBPACK FOOTER //
// ./src/components/commons-report.vue